/* Grill Master theme – v1.3: newsletter popup + quick add with variant picker */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const theme = window.gmTheme || { routes: {}, strings: {} };
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* ignore */ } },
    sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* ignore */ } },
    sdel(k) { try { window.sessionStorage.removeItem(k); } catch (e) { /* ignore */ } }
  };

  /* ---------------- Modal helpers ---------------- */
  let lastFocus = null;
  function openModal(el) {
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-open'));
    document.documentElement.classList.add('gm-lock');
    const f = $('input:not([type="hidden"]), button:not([data-pop-close]):not([data-qa-close])', el) || $('button', el);
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 80);
  }
  function closeModal(el) {
    el.classList.remove('is-open');
    setTimeout(() => { el.hidden = true; }, 220);
    if (!$('.gm-drawer.is-open')) document.documentElement.classList.remove('gm-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function trapTab(e, el) {
    if (e.key !== 'Tab') return;
    const items = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select', el).filter((x) => x.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------------- Newsletter popup ---------------- */
  /* Wait while the cookie banner is still on screen, so it never covers the popup */
  function cookieOpen() {
    const cmp = document.querySelector('pandectes-cmp');
    const root = cmp && cmp.shadowRoot;
    if (!root) return false;
    return Array.from(root.querySelectorAll('*')).some((el) => {
      const r = el.getBoundingClientRect();
      if (r.height < 40 || r.width < 200) return false;
      const s = getComputedStyle(el);
      return s.display !== 'none' && s.visibility !== 'hidden' && Number(s.opacity) > 0.05;
    });
  }
  function initPopup() {
    const pop = $('[data-gm-popup]');
    if (!pop) return;
    const KEY_SUB = 'gmPopSubscribed';
    const KEY_SEEN = 'gmPopDismissed';
    const success = $('[data-pop-success]', pop);
    const error = $('[data-pop-error]', pop);
    const submitted = store.sget('gmPopSubmitted');
    const close = () => {
      closeModal(pop);
      if (!success) store.set(KEY_SEEN, String(Date.now()));
    };
    $$('[data-pop-close]', pop).forEach((b) => b.addEventListener('click', close));
    pop.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); trapTab(e, pop); });
    const form = $('form', pop);
    if (form) form.addEventListener('submit', () => store.sset('gmPopSubmitted', '1'));

    /* Came back from submitting the popup form: show the result */
    if (submitted && (success || error)) {
      store.sdel('gmPopSubmitted');
      if (success) store.set(KEY_SUB, '1');
      openModal(pop);
      return;
    }
    if (success) { store.set(KEY_SUB, '1'); return; } /* signed up through another form */
    if (pop.hasAttribute('data-editor')) return; /* theme editor: open by selecting the section */
    if (store.get(KEY_SUB)) return;
    const seen = Number(store.get(KEY_SEEN) || 0);
    const days = Number(pop.dataset.days || 14);
    if (seen && Date.now() - seen < days * 864e5) return;
    if (/\/(cart|checkouts?|account)/.test(window.location.pathname)) return;

    let shown = false;
    const show = () => {
      if (shown) return;
      if ($('.gm-drawer.is-open') || $('.gm-qa.is-open') || cookieOpen()) { setTimeout(show, 4000); return; }
      shown = true;
      cleanup();
      openModal(pop);
    };
    const timer = setTimeout(show, Number(pop.dataset.delay || 60) * 1000);
    /* Exit intent: mouse leaves through the top of the window (desktop),
       or a quick scroll back up after reading a while (mobile) */
    const onLeave = (e) => { if (!e.relatedTarget && e.clientY <= 8) show(); };
    let lastY = window.scrollY;
    let maxY = 0;
    const armedAt = Date.now() + 15000;
    const onScroll = () => {
      const y = window.scrollY;
      maxY = Math.max(maxY, y);
      if (Date.now() > armedAt && maxY > 1200 && lastY - y > 140 && y < maxY * 0.5) show();
      lastY = y;
    };
    const exit = pop.dataset.exit === 'true';
    if (exit) {
      document.documentElement.addEventListener('mouseout', onLeave);
      if (window.matchMedia('(hover: none)').matches) window.addEventListener('scroll', onScroll, { passive: true });
    }
    function cleanup() {
      clearTimeout(timer);
      document.documentElement.removeEventListener('mouseout', onLeave);
      window.removeEventListener('scroll', onScroll);
    }
  }
  document.addEventListener('shopify:section:select', (e) => { const p = $('[data-gm-popup]', e.target); if (p) openModal(p); });
  document.addEventListener('shopify:section:deselect', (e) => { const p = $('[data-gm-popup]', e.target); if (p) closeModal(p); });

  /* ---------------- Quick add: choose a variant in a popup ---------------- */
  const fmt = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'nl', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100).replace(/^([^\d\s-]+)\s+/, '$1');
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  let qa = null;
  function qaShell() {
    if (qa) return qa;
    qa = document.createElement('div');
    qa.className = 'gm-qa';
    qa.hidden = true;
    qa.setAttribute('role', 'dialog');
    qa.setAttribute('aria-modal', 'true');
    qa.setAttribute('aria-labelledby', 'gm-qa-title');
    const closeLabel = esc(theme.strings.close || 'Sluiten');
    qa.innerHTML = `<button type="button" class="gm-qa__overlay" data-qa-close tabindex="-1" aria-label="${closeLabel}"></button><div class="gm-qa__panel"><button type="button" class="gm-qa__close gm-iconbtn" data-qa-close aria-label="${closeLabel}"><svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><div data-qa-body></div></div>`;
    document.body.appendChild(qa);
    $$('[data-qa-close]', qa).forEach((b) => b.addEventListener('click', () => closeModal(qa)));
    qa.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(qa); trapTab(e, qa); });
    return qa;
  }
  function render(p, url) {
    const body = $('[data-qa-body]', qaShell());
    const variants = p.variants;
    let current = variants.find((v) => v.available) || variants[0];
    const opts = p.options.map((o, i) => {
      const name = o.name || o;
      const values = o.values || [...new Set(variants.map((v) => v.options[i]))];
      return `<fieldset class="gm-variants"><legend>${esc(name)}</legend><div class="gm-pills">${values.map((val, j) => {
        const id = `qa-${p.id}-${i}-${j}`;
        const avail = variants.some((v) => v.options[i] === val && v.available);
        return `<input type="radio" id="${id}" name="qa-opt-${i}" value="${esc(val)}" data-i="${i}"${current.options[i] === val ? ' checked' : ''}${avail ? '' : ' class="is-unavailable"'}><label for="${id}">${esc(val)}</label>`;
      }).join('')}</div></fieldset>`;
    }).join('');
    const img = (v) => {
      const src = (v && v.featured_image && v.featured_image.src) || p.featured_image;
      return src ? `<img src="${src}${src.includes('?') ? '&' : '?'}width=400" alt="" width="200" height="200">` : '';
    };
    body.innerHTML = `<div class="gm-qa__head"><a href="${url}" class="gm-qa__img" data-qa-img>${img(current)}</a><div class="gm-stack" style="gap:6px;min-width:0"><a href="${url}" class="gm-qa__title" id="gm-qa-title">${esc(p.title)}</a><span class="gm-h gm-qa__price" data-qa-price>${fmt(current.price)}</span></div></div>
      <form method="post" action="${theme.routes.cartAdd || '/cart/add'}" data-gm-add class="gm-qa__form"><input type="hidden" name="id" value="${current.id}" data-qa-id><input type="hidden" name="quantity" value="1">${opts}
      <button type="submit" class="gm-btn gm-btn--red gm-btn--block" data-qa-btn${current.available ? '' : ' disabled'}>${current.available ? esc(theme.strings.addToCart || 'In winkelwagen') : esc(theme.strings.soldOut || 'Uitverkocht')}</button></form>
      <a href="${url}" class="gm-qa__more">${esc(theme.strings.viewProduct || 'Bekijk product')} →</a>`;
    const form = $('form', body);
    form.addEventListener('change', () => {
      const sel = p.options.map((o, i) => { const r = $(`input[name="qa-opt-${i}"]:checked`, form); return r ? r.value : null; });
      const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
      const btn = $('[data-qa-btn]', form);
      if (!v) { btn.disabled = true; btn.textContent = theme.strings.unavailable || 'Niet beschikbaar'; return; }
      current = v;
      $('[data-qa-id]', form).value = v.id;
      $('[data-qa-price]', body).textContent = fmt(v.price);
      btn.disabled = !v.available;
      btn.textContent = v.available ? (theme.strings.addToCart || 'In winkelwagen') : (theme.strings.soldOut || 'Uitverkocht');
      const im = img(v);
      if (im) $('[data-qa-img]', body).innerHTML = im;
    });
    form.addEventListener('submit', () => setTimeout(() => closeModal(qa), 30));
  }
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-pick]');
    if (!btn) return;
    e.preventDefault();
    const url = btn.dataset.quickPick;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${url.split('?')[0]}.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('fail');
      render(await res.json(), url);
      openModal(qa);
    } catch (err) {
      window.location.href = url;
    } finally {
      btn.removeAttribute('aria-busy');
    }
  });

  initPopup();
})();
